// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e7d8f67c","668":"5e4e349d","867":"ef09d026"}[chunkId] + ".chunk.js";
};